import { useCallback } from 'react';
import { HomeOutlined } from '@ant-design/icons';
import { Button } from 'components/ui';

export const ResetControl = ({ onChange }) => {
  const handleReset = useCallback(() => {
    onChange({ reset: true });
  }, [onChange]);

  return (
    <Button data-testid="ol-control-reset" title="Reset" onClick={handleReset}>
      <HomeOutlined />
    </Button>
  );
};
